module.exports = __webpack_public_path__ + "mz.svg?dec9e7e66f2dbe73dd7e5ee3ebad7736";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mz.svg
// module id = 1085
// module chunks = 27